var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    [
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px", persistent: "" },
          model: {
            value: _vm.confirmationDialog,
            callback: function($$v) {
              _vm.confirmationDialog = $$v
            },
            expression: "confirmationDialog"
          }
        },
        [
          _c("v-card", [
            _c(
              "div",
              { staticClass: "user_creation_popup_div" },
              [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "" } },
                      [
                        _c("v-card-title", [
                          _c(
                            "span",
                            { staticClass: "headline indigo--text" },
                            [
                              _c("v-icon", { attrs: { medium: "" } }, [
                                _vm._v("info_outline")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.confirmationTitle) +
                                  "\n                            "
                              )
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-card-text",
                      [
                        _c("v-flex", { attrs: { xs12: "" } }, [
                          _c("span", { staticClass: "conformationText" }, [
                            _vm._v(
                              "Are you sure you want to " +
                                _vm._s(_vm.confirmationText) +
                                " - " +
                                _vm._s(_vm.name) +
                                "??? "
                            )
                          ])
                        ])
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  [
                    _c(
                      "v-flex",
                      { staticClass: "save_in_merge", attrs: { xs12: "" } },
                      [
                        _c(
                          "v-btn",
                          {
                            class: _vm.disableActionBtn ? "disabled" : "",
                            attrs: {
                              depressed: "",
                              color: "grey lighten-3",
                              id: "actionBtn"
                            },
                            on: {
                              click: function($event) {
                                _vm.disableActionButton()
                                _vm.$emit("action")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            Yes\n                        "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "v-btn",
                          {
                            attrs: {
                              depressed: "",
                              color: "grey lighten-3",
                              id: "closePopup"
                            },
                            on: {
                              click: function($event) {
                                return _vm.$emit("close")
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                            No\n                        "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }